module.exports = __webpack_public_path__ + "img/collatz-details1.d5830f4d.png";